import { CardAnalytics } from '../../../components/library/card-analytics/CardAnalytics';
import InfoAnalyzers from '../../../components/library/info-analyzers/infoAnalyzers';

export const BoardAnalyzers = () => {
  return (
    <CardAnalytics title='Analizadores' contentClass='sales'>
      <InfoAnalyzers orientation='horizontal' />
    </CardAnalytics>
  );
};
